import apiUrl from '../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import { Validator } from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import { BasicSelect } from 'vue-search-select';
import PageTracker from '../../../common/PageTrackerHelper';
import commonService from '../../../common/common.service';
import keycloak from '../../../common/Keycloak';
import { applySmartInputStyles, clearSmartInputStyles, createClearInputWatcher } from "../../../common/inputStyleHelper";
import dummyInput from '../common/smartInput.vue'

export default {
  name: 'shipmentRecon',
  components: { VueElementLoading, BasicSelect, Validator, PageTracker,
    'dummy-input': dummyInput
  },
  mixins: [PageTracker],
  data: function () {
    return {
      ActiveTabIndex: 0,
      isLoading: false,
      isLoading1: false,
      scanLoading: false,
      radioButton: 0,
      SRTable: [],
      SummaryTable: [],
      RVPShipment: '',
      srId: '',
      srName: '',
      srList: [],
      srArrayList: [],
      srListFlt: [],
      srItemObj: { value: "", text: "", text1: "" },
      agentitem: { id: '', text: '' },
      Agent: '',
      AgentId: '',
      superagentsarray: [],
      AgentDetails: [],
      AgentSR: '',
      AgentsrName: '',
      AgentSRObj: { "value": '', "text": '' },
      AgentSRList: [],
      SRDetails: [],
      userHubId: '',
      srLoader: '',
      DeliverUserName: [],
      DeliveryUserIDArr: [],
      shippingId: '',
      comments: '',
      commentsObjList: [],
      scandiv: false,
      CloseBatchPopUp: false,
      GenerateBatchPopUp: false,
      GenerateBatchPopUpRVPQC : false,
      errormsg: '',
      commentsForManualEntry: [{ text: 'Barcode Damage', value: '1' }, { text: 'Unable to scan Barcode', value: '2' },{ text: 'Lost', value: '3' }],
      loader: '<div class="velmld-spinner"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="20px" height="18px" viewBox="0 0 24 30" xml:space="preserve"><rect x="0" y="5.59869" width="4" height="19.8026" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0s" dur="0.6s" repeatCount="indefinite"></animate></rect> <rect x="10" y="9.59869" width="4" height="11.8026" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.15s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.15s" dur="0.6s" repeatCount="indefinite"></animate></rect> <rect x="20" y="12.4013" width="4" height="6.19739" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.3s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.3s" dur="0.6s" repeatCount="indefinite"></animate></rect></svg></div>',
      radioButton2: 0,
      srId2: '',
      srList2: [],
      srItemObj2: { value: "", text: "" },
      RVPShipment: '',
      Answer: [],
      RVPQCTable: [],
      isLoadingQc: false,
      isLoadingGetQuestions: false,
      ShipmentQuestionData: [],
      agentitem2: { id: '', text: '' },
      Agent2: '',
      AgentId2: '',
      superagentsarray2: [],
      AgentSR2: '',
      AgentSRObj2: { value: "", text: "" },
      AgentSRList2: [],
      isLoadingsave: false,
      isLoadingScanShipmentsTLQC: false,
      QcQuestionAns: {},
      QCSRValues: [],
      uploadMultipleImageModal: false,
      Selectedsrname: { value: "", text: "" },
      SelectedAgentname: { id: '', text: '' },
      SelectedAgentSRname: { "value": '', "text": '' },
      QuestionsObj: { Label: "", Type: "" },
      AnswerInradio: false,
      AnswerIntext: false,
      AnswerInnumber: false,
      AnswerType: '',
      QuestionObjList: [],
      TextAns: '',
      NumberAns: '',
      countAnswer: [],
      QuestionObjListSrValue: [],
      Savebuttondisable: true,
      imageCount:1,
      NDRReasonData:'',
      isNDRLoading:false,
      checkValue : 0,
      Ismannual : false,
      SetReadonlyMode: true,
      AgentsrLoader:'',
      keyFiredCount: {'value':0},
      changeStatus : '1',
      dismissSecs: 20,
      DayEndClosureBatchDate:'',
      DayEndClosureBatchDateDiv:false,
      csvLoadingFlag: false,
      IsBrandPkgShip: false,
      brandPkgId: '',
      shipmentsBrandPkgId: '',
      isBrandPkgFlag: false,
      BPFlag: false,
      NDRAPICalled:false,
      lastInputShippingID: '0',
      bpidPopup:false,
      tryagainBPIDCount:0,
      remainingTryagainBPIDCount:3,
      bpidShippintMismatchPopup:false,
      isAllowManualEntry:'0',
      setIsMannualInscanDisableFlag:false,
      bpidShippintMismatch:false,
      userDataKey : '',
      isShowDummyInput: false,
      styleData: {},
      dummyInputTimeout: 20000,
    }
  },
  watch: {
    shippingId: createClearInputWatcher('shippingId'),
  },
  async mounted() {
    this.userDataKey = window.localStorage.getItem('userUniqueKey');
    var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userHubId = userdetail.hubdetails[0] == undefined ? 0 : userdetail.hubdetails[0]
    this.createdBy = userdetail.username;
    this.userid = userdetail.userid;
    this.userrole = userdetail.userrole[0]['rolename'];
    this.localuserid = userdetail.userid;
    this.localusermailid = userdetail.email;
    this.loadSRList(this.userHubId);
    this.getAgents(this.hubdetails);

    let setDayEndClosureFlag = await this.checkIsDayendClosureEnableforhub()
    if(!setDayEndClosureFlag) {
      this.$alertify.error('Your are not authorized user/hub for Day End Closure module.!')
      this.$router.push('/dashboard')
      return false;
    }
    console.log('setDayEndClosureFlag ----->>', setDayEndClosureFlag);

    this.setIsMannualInscanDisableFlag = await this.CheckManualInscanDisableFlagonDEC(this.userHubId)
    if(this.setIsMannualInscanDisableFlag == true) {
      if(['admin','cot team','marklost misrouteadmin'].includes(this.userrole.toLowerCase())){
        this.isAllowManualEntry = '1';
        this.checkValue = 1;
      }else {
        this.isAllowManualEntry = '0';
        this.checkValue = 0;
      }
    }else {
       this.isAllowManualEntry = '1';
       this.checkValue = 1;
    }

    let TrackerInfo = {
      projectname: "Lastmile-web",
      type: "Web",
      userid: this.localuserid,
      username: this.localusermailid,
      meta: {
        "event": ""
      }
    }
    let result = this.PageTracker(TrackerInfo);
    //console.log('Mixin is working for :',result);
  },

  methods: {
    async validateForm(scope) {
      // console.log('1 . Inside validateForm');
      // console.log('2. this.NDRAPICalled',this.NDRAPICalled);
      this.scanLoading = true;
      // if(this.NDRAPICalled==false ||( this.NDRAPICalled == true && this.lastInputShippingID != this.shippingId)) {
      //   this.lastInputShippingID = this.shippingId;
      //   let getReasonandbrandedPack = await this.getNDrReasonBrandedPackedId(this.shippingId, this.userHubId, this.DeliveryUserID)
      // }
      this.DeliveryUserID = parseInt(this.srItemObj.value, 10) || parseInt(this.AgentSRObj.value, 10)
      if (this.lastInputShippingID != this.shippingId) {
        // console.log('Call NDR API.!!---->',this.shippingId);
        this.lastInputShippingID = this.shippingId;
        let getReasonandbrandedPack = await this.getNDrReasonBrandedPackedId(this.shippingId, this.userHubId, this.DeliveryUserID)
        // console.log('flag this.NDRAPICalled----->',this.NDRAPICalled);
        this.FinalSubmitInscan(scope)
      } else if (this.lastInputShippingID == this.shippingId && this.NDRAPICalled == false) {
        // console.log('Duplicate function calling...--->',this.shippingId);
      } else if (this.lastInputShippingID == this.shippingId && this.NDRAPICalled == true) {
        // console.log('Finally Submit Form.!!--->',this.shippingId);
        this.FinalSubmitInscan(scope)
      }else{
        this.FinalSubmitInscan(scope);
      }
    },
    FinalSubmitInscan(scope) {
      this.$validator.validateAll(scope).then(validationResult => {
        if (validationResult) {
          // console.log('Form Submitted Successfully .!!!!!');
          if (this.BPFlag == true && this.brandPkgId.length < 4) {
            this.$alertify.error("Please enter at least Last 4 digits of Branded PackagingID.!")
            $("#brandPkgId").focus();
            this.scanLoading = false;
            return false;
          } else {
            if (this.BPFlag == true && !this.checkBrandedPackagingIDFormatCheck(this.brandPkgId)) {
              this.$alertify.error("Branded Packging ID is Required.");
              this.scanLoading = false;
              return false;
            }
            // else if(this.BPFlag == true && this.isBrandPkgFlag == false){
            //   this.checkBrandPkgIDIsNotAWB()
            //   this.scanLoading = false;
            // }else {
            //   this.ScanShipments(this.shippingId);
            // }
            this.ScanShipments(this.shippingId);
          }
        } else {
          this.scanLoading = false;
          let focusElement = '#' + this.$validator.errors.items[0].field;
          if (focusElement)
            $(focusElement).focus()
        }
      })
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    countDownChangedSuccess(dismissCountDownSuccess) {
      this.dismissCountDownSuccess = dismissCountDownSuccess
    },
    handleDragOver(event){
      event.preventDefault();
    },
    oncallImediate(keycode){
      // this.keyFiredCount.value = 0;
      // console.log('keycode ------>>', keycode);
      // console.log('vm.keyFiredCount ------>>', this.keyFiredCount);
      if ($("#shippingId").val() == '' || $("#brandPkgId").val() == ''){
        this.keyFiredCount.value = 0;
        this.comments = '';
        return false;
      }
      else if(($("#shippingId").val() != '' || $("#brandPkgId").val() != '') && this.keyFiredCount.value <= 1 && keycode == 13 ) {
        this.Ismannual = false;
        this.checkValue = 0;
        // this.keyFiredCount.value = 0;
        console.log('Input given from scanner.!');
      }
      else {

        if(this.setIsMannualInscanDisableFlag == true) {
          if(['admin','cot team','marklost misrouteadmin'].includes(this.userrole.toLowerCase()) && keycode != 13){
            this.isAllowManualEntry = '1';
            this.checkValue = 1;
          }else {
            this.isAllowManualEntry = '0';
            this.checkValue = 0;
          }
        }else{
          if (keycode != 13){
            this.isAllowManualEntry = '1';
            this.checkValue = 1;
          }
          else{
            this.isAllowManualEntry = '0';
            this.checkValue = 0;
          }
        }

        if (($("#shippingId").val() != '' || $("#brandPkgId").val() != '') && this.keyFiredCount.value <= 1 && keycode != 13 && this.isAllowManualEntry == '0' && (!['admin','cot team','marklost misrouteadmin'].includes(this.userrole.toLowerCase()) && this.setIsMannualInscanDisableFlag)) {
          this.$alertify.error('Please scan AWB again');
          if(this.shippingId && !this.brandPkgId){
            this.shippingId = "";
          }
          if(this.shippingId && this.brandPkgId){
            this.brandPkgId = '';
          }
          return false;
        }else {
          console.log('User Input detection .!');
          this.Ismannual = true;
          this.checkValue = 1;
        }
      }
    },
    DelayExecution(f, delay) {
      var timer = null;
      return function () {
        var context = this, args = arguments;
        clearTimeout(timer);
        timer = window.setTimeout(function () {
            f.apply(context, args);
        },
        delay || 200);
      };
    },
    setIsMannual(){
      if(this.shippingId == '' ) {
        this.Ismannual = false;
        this.checkValue = 0;
      }
      if(this.BPackingID == '' ) {
        this.Ismannual = false;
      }
    },
  //   keyHandler () {
  //     this.Ismannual = true;
  //     this.checkValue = 1;
  //     if(this.shippingId == ''){
  //       this.Ismannual = false;
  //       this.checkValue = 0;
  //     }
  // },
    KeyHandle(){
      // this.NDRReasonData = '';
      const vm = this;
      vm.keyFiredCount.value = 0;
      //var keyupFiredCount = 0;
      if($("#shippingId").val() != ''){
        $("#shippingId").keyup(this.DelayExecution(function (event) {
          // this.Ismannual = true;
          // this.checkValue = 1;
          let keycode = (event.keyCode ? event.keyCode : event.which);
          vm.keyFiredCount.value = vm.keyFiredCount.value + 1;
          vm.oncallImediate(keycode);
          vm.setIsMannual();
        }));
      }
      if($("#brandPkgId").val() != ''){
        $("#brandPkgId").keyup(this.DelayExecution(function (event) {
          // this.Ismannual = true;
          let keycode = (event.keyCode ? event.keyCode : event.which);
          vm.keyFiredCount.value = vm.keyFiredCount.value + 1;
          vm.oncallImediate(keycode);
          vm.setIsMannual();
        }));
      }
    },
   //  showUploadFileComments(){
   //
   //    if(this.Ismannual == true) {
   //     this.checkValue = 1
   //    }else {
   //     this.checkValue = 0
   //     ScanShipments(this.shippingId);
   //    }
   //
   // },
    reloadP() {
      // this.isLoadingQc = true;
      // this.isLoading = true;
      this.isNDRLoading = true;
      // document.location.reload();
     },
    OpenRVPTab() {
      if (this.SRTable[0].PickedUP > 0) {
        if (this.radioButton == 0) {
          this.ActiveTabIndex = 1
          this.radioButton2 = 0
          this.Selectedsrname = this.srItemObj
          this.srId2 = this.Selectedsrname,
            this.RVPQCTableData();
        }
        else if (this.radioButton == 1) {
          this.ActiveTabIndex = 1
          this.radioButton2 = 1
          this.SelectedAgentname = this.agentitem
          this.Agent2 = this.SelectedAgentname,
            this.SelectedAgentSRname = this.AgentSRObj
          this.AgentSR2 = this.SelectedAgentSRname
          this.RVPQCTableData();
        }
        else {
          this.$alertify.error("Can't redirect to RVP QC Tab")

        }
      }
      else {
        this.$alertify.error("Shipments are not available for RVP QC check.")
      }
    },
    //Tab clear
    SRTabData() {
      this.DayEndClosureBatchDate=''
      this.DayEndClosureBatchDateDiv=false;
      this.SRTable = [];
      this.scandiv = false;
      this.agentitem = { id: '', text: '' },
      this.AgentSRList = [],
        this.AgentSRObj = { "value": '', "text": '' },
        this.shippingId = '',
        this.comments = '',
        this.checkValue = 0,
        this.NDRReasonData = '',
        this.AgentId = '',
        this.SummaryTable = [],
        this.AgentSR = ''
        this.ShowSummaryTable(this.userHubId);

    },
    AgentTabData() {
      this.DayEndClosureBatchDate='';
      this.DayEndClosureBatchDateDiv=false;
      this.SRTable = [];
      this.srItemObj = { value: "", text: "", text1: "" },
      this.scandiv = false;
      this.shippingId = '',
      this.comments = '',
      this.checkValue = 0,
      this.NDRReasonData = '',
      this.SummaryTable = []
    },
    SRTabData2() {
      this.RVPQCTable = [];
      this.AgentSRList2 = [];
      this.agentitem2 = { id: '', text: '' }
      this.AgentSRObj2 = { value: "", text: "" },
      this.Selectedsrname = { value: "", text: "" },
      this.SelectedAgentname = { id: '', text: '' },
      this.AgentSR2 = ''
      this.Agent2 = '',
      this.SelectedAgentSRname = { "value": '', "text": '' }
    },
    AgentTabData2() {
      this.RVPQCTable = [];
      this.srItemObj2 = { value: "", text: "" },
        this.srId2 = ''
    },
    //Shipment Reconciliation
    //SR list dropdown for Reconciliation
    getSRs(obj) {
      this.DayEndClosureBatchDate=''
      this.DayEndClosureBatchDateDiv=false;
      this.srItemObj = obj
      this.srId = this.srItemObj.value
      this.srName = obj.text1
      this.SRTable = [],
        this.SRTableData();
        this.Reset();
        this.scandiv = false;
    },
    loadSRList(hubid) {
      this.srLoader = this.loader
      this.srArrayList = []
      this.srList = []
      this.srListFlt = []
      if (hubid) {
        this.input = {
          "usertype": "3",
          "hubid": [hubid]
        }
        let apiendpoint = 'expose/users/HubDeliveryUsers/get/List';
        if (keycloak.enableKavach) {
            apiendpoint = 'user/migration/gethubdeliveryuserlist';
        }
        axios({
          method: 'POST',
          url: apiUrl.api_url + apiendpoint,
          data: this.input
        })
          .then(result => {
            if (result.data.data.code == 200) {
              this.srArrayList = result.data.data.results;
              for (var i = 0; i < this.srArrayList.length; i++) {
                this.srList.push({
                  value: this.srArrayList[i].userid,
                  text: `${this.srArrayList[i].FirstName} ${this.srArrayList[i].LastName} (${this.srArrayList[i].OldDeliveryUserOrUserId}) (${this.srArrayList[i].userid})`,
                  text1: `${this.srArrayList[i].FirstName} ${this.srArrayList[i].LastName}`
                })
                this.srList2.push({
                  value: this.srArrayList[i].userid,
                  text: `${this.srArrayList[i].FirstName} ${this.srArrayList[i].LastName} (${this.srArrayList[i].OldDeliveryUserOrUserId}) (${this.srArrayList[i].userid})`

                })
              }
              this.srLoader = ''
            } else {
              this.$alertify.error(result.data.data.message ? result.data.data.message : 'No Record found')
            }
            this.ShowSummaryTable(this.userHubId);

          }, error => {
            console.error(error)
          })
      }
      else {
        this.$alertify.error("Current Hub Id not found.")
      }
    },

    //Agent dropdown List
    SelectAgent(agentitem) {
      this.DayEndClosureBatchDate=''
      this.DayEndClosureBatchDateDiv=false;
      this.scandiv = false;
      this.agentitem = agentitem
      this.Agent = this.agentitem.text
      this.AgentId = this.agentitem.id
      this.AgentSRObj= { "value": '', "text": '' },
      this.SRTable = [],
      this.getDeliveryUserName(this.hubdetails);
      // this.ShowSummaryTable(this.userHubId);
    },
    getAgents() {
      let inputPayload = {
        "EntityType": 'Agent',
        "HubID": this.userHubId
      }
      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'AgentHandover/getAgentList',
        'data': inputPayload,
        header: {
          'content-type': 'application/json'
        }
      })
        .then((result) => {
          this.AgentDetails = result.data.data;
          for (var i = 0; i < this.AgentDetails.length; i++) {

            this.superagentsarray.push({
              "id": this.AgentDetails[i].id,
              "text": this.AgentDetails[i].name,
            })
            this.superagentsarray2.push({
              "id": this.AgentDetails[i].id,
              "text": this.AgentDetails[i].name,
            })

          }
        })
        .catch((httpException) => {
          this.$alertify.error("Agent data not found");
          console.error('exception is:::::::::', httpException)
        })
    },
    //Get SR list by Agent
    selectDeliveryUser(obj) {
      this.AgentSRObj = obj;
      this.AgentSR = obj.value;
      this.AgentsrName = obj.text2
      this.SRTableData();
      this.Reset();
      this.scandiv = false;
    },
    getDeliveryUserName(hubid) {
      this.srLoader = this.loader;
      this.AgentSRList = [];
      let Emppayload = {}
      let apiendpoint = 'agenthandovershipments/getDeliveryUserName';
      if (keycloak.enableKavach) {
        apiendpoint = 'user/migration/getoutsourceuserlist';
      }
      axios({
        method: 'POST',
        url: apiUrl.api_url + apiendpoint,
        data: { "Emppayload": { "appkey": "$LAST$Mile%#$", "hubid": [this.userHubId], "OutSourcingId": this.AgentId } }
      })
        .then((response) => {
          if (response.data.code === 200) {
            this.AgentSRList = [];
            this.SRDetails = response.data.data;
            for (var i = 0; i < this.SRDetails.length; i++) {
              this.AgentSRList.push({
                value: `${this.SRDetails[i].DeliveryUserId}`,
                text: `${this.SRDetails[i].FirstName} ${this.SRDetails[i].LastName} (${this.SRDetails[i].DeliveryUserId}) `,
                text2: `${this.SRDetails[i].FirstName} ${this.SRDetails[i].LastName}`
              })

              this.AgentSRList2.push({
                value: `${this.SRDetails[i].DeliveryUserId}`,
                text: `${this.SRDetails[i].FirstName} ${this.SRDetails[i].LastName} (${this.SRDetails[i].DeliveryUserId}) `,
              })
            }
            this.ShowSummaryTable(this.userHubId);//change
          } else {
            this.AgentSRList = [];
            this.$alertify.error("Delivery User Data Not Found");
          }
          this.srLoader = '';
        })
        .catch((httpException) => {
          this.srLoader = '';
          console.error('exception is:::::::::', httpException)
        })
    },

    OpenScandiv() {
      if (this.SRTable[0].FwdUnDelivered > 0 || this.SRTable[0].RTODTOUnDelivered > 0 ) {
        // this.scandiv = true;
        this.$nextTick(() => {
          this.$refs["shippingId"].focus()
        })
      }
      else {
        // this.scandiv = false;
        this.$alertify.error("No pending Shipments")
      }
    },

    Reset() {
      this.shippingId = '',
      this.comments = '',
      this.NDRReasonData = '',
      this.checkValue = 0
      this.Ismannual = false;
      this.shipmentsBrandPkgId = '';
      this.brandPkgId = '';
      this.IsBrandPkgShip = false;
      this.isBrandPkgFlag = false;
      this.NDRAPICalled = false;
      this.BPFlag = false;
      this.lastInputShippingID = '0',
      this.isAllowManualEntry = '0',
      this.isShowDummyInput = false;
      if (this.$refs.dummyShipInputBox) {
        this.$refs.dummyShipInputBox.clearStyles();
      }
    },

    // Right Table
    ShowSummaryTable(hubid) {
      this.isLoading1 = true;
      if (hubid) {
        this.input = {
          "HubID": this.userHubId,
        }
        if(this.AgentId){
          this.input = {
          "HubID": this.userHubId,
          "CourierCompanyID":this.AgentId
          }
        }
        axios({
          method: 'POST',
          url: apiUrl.api_url + 'DayEndClosure/getEODShipmentSummaryReport',
          data: this.input
        })
          .then(result => {
            this.SummaryTable = []
            if (result.data.code == 200) {
              let tempArray = result.data.data;
              if(this.radioButton == '0') {
                tempArray.map((e,idx) => {
                  let getresult = this.srArrayList.find((obj) => obj.userid == e.deliveryuserid )
                  if(getresult && getresult != undefined) {
                    e.username = `${getresult.FirstName} ${getresult.LastName} (${getresult.OldDeliveryUserOrUserId}) (${getresult.userid})`
                    this.SummaryTable.push(e)
                  }
                });
              } else if (this.radioButton == '1') {

                if (this.AgentId) {
                  tempArray.map(e => {
                    let agentSR = this.SRDetails.find((obj) => obj.DeliveryUserId == e.deliveryuserid )

                    if(agentSR && agentSR != undefined) {
                      e.username = `${agentSR.FirstName} ${agentSR.LastName} (${agentSR.DeliveryUserId})`
                      this.SummaryTable.push(e)
                    }
                    // for (let i of this.SRDetails) {
                    //   if (e.DeliveryUserID == i.DeliveryUserId) {
                    //     e.username = i.FirstName + " " + i.LastName
                    //   }
                    // }
                  });
                }
              }
              this.isLoading1 = false;
            }
            else if (result.data.code === 204 || result.data.code === 205) {
              this.isLoading1 = false;
            }
            else {
              this.isLoading1 = false;
              this.$alertify.error("Shipment Summary Not found")
            }
          })
      } else {
        this.isLoading1 = false;
        this.$alertify.error("Current Hub Id not found.")
      }
    },
    // Left Table
    SRTableData() {
      this.shippingId = '',
      this.DayEndClosureBatchDate=''
      this.DayEndClosureBatchDateDiv=false;
      this.comments = ''
      this.isLoading = true;
      this.input = {
        "DeliveryUserID": parseInt(this.srId, 10),
        "HubID": this.userHubId,
        "LastModifiedBy": this.localusermailid
      }
      if (this.AgentSR) {
        this.input = {
          "DeliveryUserID": parseInt(this.AgentSR, 10),
          "HubID": this.userHubId,
          "OutSourcingMasterId":this.AgentId,
          "LastModifiedBy": this.localusermailid
        }
      }
      axios({
        method: 'POST',
        url: apiUrl.api_url + 'DayEndClosure/getEODShipmentReport',
        data: this.input
      })
        .then(result => {
          if (result.data.code == 200) {
            this.dismissCountDownSuccess = this.dismissSecs
            this.SRTable = [];
            this.SRTable = result.data.data;
            this.DayEndClosureBatchDate= 'Day End Closure Batch Created Date : '+this.SRTable[0].DayEndClosureBatchDate;
            if( this.SRTable[0].Status=='InProgress'){
              this.scandiv = true;
            }else{
              this.scandiv = false;
            }
            this.SRTable.map(e => {
              for (let i of this.srArrayList) {
                if (e.DeliveryUserID == i.userid) {
                  e.Name = `${i.FirstName} ${i.LastName} (${i.OldDeliveryUserOrUserId}) (${i.userid})`
                }
              }
            });
            if (this.AgentSR) {
              this.SRTable.map(e => {
                for (let i of this.SRDetails) {
                  if (e.DeliveryUserID == i.DeliveryUserId) {
                    e.Name = `${i.FirstName} ${i.LastName} (${i.OldDeliveryUserOrUserId}) (${i.userid})`
                  }
                }
              });
            }
            this.isLoading = false;
            this.dismissCountDown = this.dismissSecs
          }
          else if (result.data.code === 204) {
            this.isLoading = false;
            this.SRTable = [];
            this.GenerateBatchPopUp = true;
          }
          else if (result.data.code === 205) {
            this.isLoading = false;
            this.SRTable = [];
            this.errormsg = result.data.message
            this.$alertify.error(result.data.message)
            this.CloseBatchPopUp = true;
          }
          else {
            this.DayEndClosureBatchDate='';
            this.DayEndClosureBatchDateDiv=false;
            this.SRTable = [];
            this.isLoading = false;
            this.$alertify.error("SR data Not found")
          }
        })
    },

//To show scantally popups
    SRTableDataRVPQC() {
      this.shippingId = '',
      this.comments = ''
      this.isLoading = true;

      if(this.srId2){
        this.input = {
          // "DeliveryUserID": parseInt(this.srId2, 10),
          "HubID": this.userHubId
        }
      }
      if (this.AgentSR2) {
        this.input = {
          // "DeliveryUserID": parseInt(this.AgentSR2, 10),
          "HubID": this.userHubId
        }
      }
      axios({
        method: 'POST',
        url: apiUrl.api_url_for_scantally + 'DayEndClosure/CheckCurrentOpenedBatchForHubID',
        data: this.input
      })
        .then(result => {
          if (result.data.code == 200) {
            this.GenerateBatchPopUp = false;
            this.GenerateBatchPopUpRVPQC = false;
            if(this.srId2){
              this.RVPQCTableData();
            } else if (this.AgentSR2){
              this.RVPQCTableData();
            }

          }else if (result.data.code === 204) {
            this.isLoading = false;
            this.SRTable = [];
            this.RVPQCTable = [];
            this.GenerateBatchPopUpRVPQC = true;
          }
          else if (result.data.code === 205) {
            this.isLoading = false;
            this.SRTable = [];
            this.RVPQCTable = [];
            this.CloseBatchPopUp = true;
          }else if (result.data.code === 202) {
            this.SRTable = [];
            this.RVPQCTable = [];
            this.isLoading = false;
            this.GenerateBatchPopUpRVPQC = false;
            this.RVPQCTableData();
          }
          else if (result.data.code === 206) {
            this.SRTable = [];
            this.RVPQCTable = [];
            this.isLoading = false;
            this.GenerateBatchPopUpRVPQC = false;
            this.RVPQCTableData();
          }
          else {
            this.SRTable = [];
            this.RVPQCTable = [];
            this.isLoading = false;
            this.GenerateBatchPopUpRVPQC = false;
            this.RVPQCTableData();
            // this.$alertify.error("SR data Not found")
            // this.$alertify.error(result.data.message)
          }
        })
    },

    Refreshdata() {
      if (this.SRTable.length == 0) {
        this.ShowSummaryTable(this.userHubId);
      }
      else {
        this.DeliveryUserID = parseInt(this.srItemObj.value, 10) || parseInt(this.AgentSRObj.value, 10);
        // if ((parseFloat(this.SRTable[0].FwdUnDelivered) + parseFloat(this.SRTable[0].RTODTOUnDelivered) +
        // parseFloat(this.SRTable[0].RVPPickedUp)) == parseFloat(this.SRTable[0].Scanned)) {
        //   this.updateEODBatchStatus(this.DeliveryUserID,this.userHubId,this.localusermailid);
        // }

        this.ShowSummaryTable(this.userHubId);
        this.SRTableData();
      }
      this.NDRReasonData = '';
      this.Reset();
    },
    //Routing to the shipment scantally
    Clickhere() {
      this.$router.push({
        name: 'Shipment ScanTally',
        path: '/ShipmentScanTallyNew/',
        component: 'ShipmentScanTallyNew',
        params: { id: changeStatus }
      });
      this.closepopup();
    },
    closepopup() {
      this.CloseBatchPopUp = false;
      this.GenerateBatchPopUp = false;
      this.GenerateBatchPopUpRVPQC = false;
      this.bpidPopup = false;
      this.bpidShippintMismatch = false
    },
    Clear() {
      this.scandiv = false
    },

    //RVP QC Check_---------------------
    //TlQc sr list
    getSRs2(obj) {
      this.Selectedsrname = obj
      this.srId2 = this.Selectedsrname.value
      this.srItemObj2 = obj
      this.srId2 = this.srItemObj2.value
      this.SRTableDataRVPQC(this.srId2);
      // this.RVPQCTableData();
    },
    //Agent dropdown List
    SelectAgent2(obj) {
      this.scandiv = false;
      this.SelectedAgentSRname = { "value": '', "text": '' },
      this.AgentSRObj2 = { value: "", text: "" },
      this.agentitem2 = obj
      this.Agent2 = this.agentitem2.text
      this.AgentId2 = this.agentitem2.id
      this.SelectedAgentname = obj
      this.Agent2 = this.SelectedAgentname.text
      this.RVPQCTable = [];
      this.getDeliveryUserName2();
    },
    //Get SR list by Agent
    selectDeliveryUser2(obj) {
      this.AgentSRObj2 = obj;
      this.AgentSR2 = obj.value;
      this.SRTableDataRVPQC(this.AgentSR2);
      this.SelectedAgentSRname = obj;
      this.AgentSR2 = obj.SelectedAgentSRname.text;
      this.SRTableDataRVPQC(this.AgentSR2);
      this.RVPQCTableData();
    },
    getDeliveryUserName2() {
      this.AgentsrLoader = this.loader;
      this.AgentSRList2 = [];
      let Emppayload = {}
      let apiendpoint = 'agenthandovershipments/getDeliveryUserName';
      if (keycloak.enableKavach) {
        apiendpoint = 'user/migration/getoutsourceuserlist';
      }
      axios({
        method: 'POST',
        url: apiUrl.api_url + apiendpoint,
        data: { "Emppayload": { "appkey": "$LAST$Mile%#$", "hubid": [this.userHubId], "OutSourcingId": this.AgentId2 } }
      })
        .then((response) => {
          if (response.data.code === 200) {
            this.AgentSRList2 = [];
            this.SRDetails = response.data.data;
            for (var i = 0; i < this.SRDetails.length; i++) {
              this.AgentSRList2.push({
                value: `${this.SRDetails[i].DeliveryUserId}`,
                text: `${this.SRDetails[i].FirstName} ${this.SRDetails[i].LastName} (${this.SRDetails[i].DeliveryUserId}) `,
              })
            }
          } else {
            this.AgentSRList2 = [];
            this.$alertify.error("Delivery User Data Not Found");
          }
          this.AgentsrLoader = '';
        })
        .catch((httpException) => {
          this.AgentsrLoader = '';
          console.error('exception is:::::::::', httpException)
        })
    },

    // RVP QC SR  TableData
    RVPQCTableData() {
      this.isLoading = false
      this.isLoadingQc = true;
      if (typeof this.srId2 == 'object') {
        this.srId2 = this.srId2.value
      }
      this.input = {
        "DeliveryUserId": this.srId2.toString(),
        "HubId": this.userHubId,
        "CourierCompanyID": this.AgentId2.toString(),
        "IsRVPQCCheck": true
      }
      if (this.AgentSR2) {
        if (typeof this.AgentSR2 == 'object') {
          this.AgentSR2 = this.AgentSR2.value
        }
        this.input = {
          "DeliveryUserId": this.AgentSR2.toString(),
          "HubId": this.userHubId,
          "CourierCompanyID": this.AgentId2.toString(),
          "IsRVPQCCheck": true
        }
      }
      axios({
        method: 'POST',
        url: apiUrl.api_url + 'DayEndClosure/getRVPShipmentDetails',
        data: this.input
      })
        .then(result => {
          if (result.data.code == 200) {
            this.RVPQCTable = [];
            this.isLoadingQc = false;
            this.RVPQCTable = result.data.data;
          } else if (result.data.code == 202) {
            this.RVPQCTable = [];
            this.isLoadingQc = false;
            this.$alertify.error(result.data.message)
          }
          else {
            this.RVPQCTable = [];
            this.isLoadingQc = false;
            this.$alertify.error("Shipment data Not found")
          }
        })
    },

    ValidateBrandedPkgId(){
      this.bpidPopup = false
      this.bpidShippintMismatch = false
      if(this.BPFlag == true && this.brandPkgId.length < 1){
        this.$alertify.error("Please enter Branded PackagingID.!")
        $("#brandPkgId").focus();
        return false;
      } else {
        if(this.shipmentsBrandPkgId.trim().toLowerCase() == this.brandPkgId.trim().toLowerCase()){
          this.isBrandPkgFlag = true;
        }
        else{
          this.isBrandPkgFlag = false;
        }
    }
      // if(this.checkValue != 1 && this.brandPkgId != ''){
      //   this.ScanShipments(this.shippingId)
      // }
    },

    // async commonScanShipFun(shippingId, eventType = ''){
    //
    //   this.DeliveryUserID = parseInt(this.srItemObj.value, 10) || parseInt(this.AgentSRObj.value, 10)
    //   if(this.NDRAPICalled==false) {
    //     let getReasonandbrandedPack = await this.getNDrReasonBrandedPackedId(this.shippingId, this.userHubId, this.DeliveryUserID)
    //   }
    //   this.scanLoading = true;
    //
    //   if (this.shippingId.trim() == '') {
    //     this.NDRAPICalled = false
    //     this.IsBrandPkgShip = false;
    //     this.brandPkgId = '';
    //     this.$alertify.error("Please enter ShippingId");
    //     this.scanLoading = false;
    //   }
    //   else if (this.checkValue == 1 && this.comments == '') {
    //     // console.log("checkValue",this.checkValue);
    //     if(eventType == 'onchange') {
    //       // $("#shippingId").focus();
    //       // this.NDRAPICalled = false;
    //       this.brandPkgId = '';
    //     }
    //     if(this.BPFlag == true){
    //       $("#brandPkgId").focus();
    //     }
    //     this.$alertify.error("Please select comments")
    //     this.scanLoading = false;
    //   } else {
    //     if(this.BPFlag == true){
    //       $("#brandPkgId").focus();
    //       if(this.BPFlag == true && this.brandPkgId == ''){
    //         this.$alertify.error("Please enter Branded PackagingID.!")
    //         this.scanLoading = false;
    //         return false;
    //       }
    //       else if(this.BPFlag == true && this.brandPkgId.length < 4){
    //         this.$alertify.error("Please enter at least Last 4 digits of Branded PackagingID.!")
    //         this.scanLoading = false;
    //         $("#shippingId").focus();
    //         return false;
    //       } else {
    //         this.ValidateBrandedPkgId();
    //         // //true.
    //         // let inputsLastFour = this.brandPkgId.trim().substr(-4);
    //         // let shipmentsBPId = this.shipmentsBrandPkgId.trim().substr(-4);
    //         // if(shipmentsBPId == inputsLastFour){
    //         //   this.isBrandPkgFlag = true;
    //         // }
    //         // else{
    //         //   this.isBrandPkgFlag = false;
    //         // }
    //        if(this.checkValue ==1){
    //          this.ScanShipments(shippingId);
    //        }
    //       }
    //     }
    //     else{
    //       this.ScanShipments(shippingId);
    //     }
    //   }
    // },

    //ScanShipments API
    ScanShipments(shippingId) {
      this.isShowDummyInput = false;
      // this.shippingId = shippingId;
      this.DeliveryUserID = parseInt(this.srItemObj.value, 10) || parseInt(this.AgentSRObj.value, 10)

      this.input = {
        "ShippingID": shippingId,
        "DeliveryUserID": this.DeliveryUserID,
        "HubID": this.userHubId,
        "LastModifiedBy": this.localusermailid,
        "IsInscan": true,
        "ManualScanReason":this.comments,
      }

      if(this.IsBrandPkgShip == true && this.brandPkgId.trim()){
        this.input.isbppackageid = this.isBrandPkgFlag;
        this.input.BPPackageID = this.brandPkgId
      }

      axios({
        method: 'POST',
        url: apiUrl.api_url + 'DayEndClosure/updateEODInscanShipment',
        data: this.input
      })
      .then(response => {
        if (response.data.code == 200) {
          this.scanLoading = false;
          this.$alertify.success(response.data.data.ScanMessage);

          this.SRTable[0].Scanned = response.data.data.Scanned;
          this.SRTable[0].Lost = response.data.data.Lost;
          this.SRTable[0].Status = response.data.data.Status;
          if ((parseFloat(this.SRTable[0].FwdUnDelivered) + parseFloat(this.SRTable[0].RTODTOUnDelivered) +
            parseFloat(this.SRTable[0].RVPPickedUp)) == parseFloat(this.SRTable[0].Scanned)+this.SRTable[0].Lost) {
            //this.updateEODBatchStatus(this.DeliveryUserID,this.userHubId,this.localusermailid);
            this.Refreshdata();
          }

        }
        else if (response.data.code == 202) {
          this.scanLoading = false;
          this.$alertify.error(response.data.data.ScanMessage);
        }
        // else if(response.data.code == 203){
        //   this.scanLoading = false;
        //   this.$alertify.error(response.data.data.ScanMessage);
        //   if (this.radioButton == 0) {
        //     this.ActiveTabIndex = 1
        //     this.radioButton2 = 0
        //     this.Selectedsrname = this.srItemObj
        //     this.srId2 = this.Selectedsrname,
        //       this.RVPQCTableData();
        //   }
        //   else if (this.radioButton == 1) {
        //     this.ActiveTabIndex = 1
        //     this.radioButton2 = 1
        //     this.SelectedAgentname = this.agentitem
        //     this.Agent2 = this.SelectedAgentname,
        //       this.SelectedAgentSRname = this.AgentSRObj
        //     this.AgentSR2 = this.SelectedAgentSRname
        //     this.RVPQCTableData();
        //   }
        // } else if (response.data.code == 204) {
        //   this.scanLoading = false;
        //   this.$alertify.error(response.data.data.ScanMessage);
        //   this.shippingId = '',
        //   this.comments = '',
        //   this.IsBrandPkgShip = false;
        //   this.brandPkgId = ''
        // }
        // else if (response.data.code == 206) {
        //   this.scanLoading = false;
        //   this.$alertify.error(response.data.data.ScanMessage);
        //   this.shippingId = '',
        //   this.comments = '',
        //   this.IsBrandPkgShip = false;
        //   this.brandPkgId = ''
        // }
        else {
          this.scanLoading = false;
          this.$alertify.error("Error While scanning shipment!");
        }
      })
      $("#shippingId").focus();
      this.resetscanfields()
    },
    resetscanfields() {
      this.lastInputShippingID = '0'
      this.NDRAPICalled = false;
      this.shippingId = '',
      this.comments = '',
      this.Ismannual = false;
      this.checkValue = 0;
      // this.NDRReasonData = '';
      this.IsBrandPkgShip = false;
      this.brandPkgId = ''
      this.BPFlag = false
      this.keyFiredCount.value = 0;
      this.$validator.reset();
      this.errors.clear();
    },
    Reload2() {
      this.RVPQCTableData();
    },
    ScanShipmentToGetQuestions() {
       if (this.RVPShipment == '') {
        this.$alertify.error("Please enter Shipping Id");
      }
      else if(this.RVPQCTable.find(o => o.ShippingID == this.RVPShipment)){
        this.isLoadingGetQuestions = true;
        this.input = {
          "ShippingID": this.RVPShipment,
          "HubId": this.userHubId,
          "DeliveryUserId": this.srId2.toString(),
        }
        axios({
          method: 'POST',
          url: apiUrl.api_url + 'DayEndClosure/getRVPShipmentDetails',
          data: this.input
        })
          .then(result => {
            if (result.data.code == 200) {
              let QuestionObjList1 = []
              this.ShipmentQuestionData = result.data.data;
              if (this.ShipmentQuestionData[0].TLQC == 'Y') {
                if (this.ShipmentQuestionData[0].QCParameters == null) {
                  this.$alertify.error("No questions are available for this Shipment.");
                  this.isLoadingGetQuestions = false;
                  this.QuestionObjList = []
                }
                else {
                  this.isLoadingGetQuestions = false;
                  this.QuestionObjList1 = []

                  result.data.data[0].QCParameters.forEach(element => {
                      QuestionObjList1.push({
                        'Type': element.Type,
                        'Lable': element.Label || element.Lable,
                        'SRValue': element.Value
                      }
                      )
                    });


                  this.QuestionObjList = QuestionObjList1
                  this.Savebuttondisable = false
                  if(this.QuestionObjList.length == 0){
                   this.$alertify.error("No questions are available for this Shipment.");
                  }
                }
              } else if (this.ShipmentQuestionData[0].TLQC == 'N') {
                this.$alertify.error("TLQC Execution is not Required.");
                this.isLoadingGetQuestions = false;
                this.QuestionObjList = []
              } else {
                this.QuestionObjList = []
                this.isLoadingGetQuestions = false;
                this.$alertify.error("TLQC Execution is not Required.");
              }
            } else if(result.data.code == 202){
              this.QuestionObjList = []
              this.isLoadingGetQuestions = false;
              this.$alertify.error("TL QC already done for the shipment")
            }
          })
      }
      else{
        this.$alertify.error("Invalid ShippingId")
      }
    },
    AnsYes(item) {
      this.QcQuestionAns[item] = "Yes"
      this.countAnswer.push("Yes")
      let QCSRValuesobj = {}
      QCSRValuesobj.Lable = item
      QCSRValuesobj.Value = "Yes"
      this.QCSRValues.push(QCSRValuesobj)
    },
    AnsNo(item) {
      this.QcQuestionAns[item] = "No"
      this.countAnswer.push("No")
      let QCSRValuesobj = {}
      QCSRValuesobj.Lable = item
      QCSRValuesobj.Value = "No"
      this.QCSRValues.push(QCSRValuesobj)
    },
    AnsText(value, item) {
      this.QcQuestionAns[item] = value
      this.countAnswer.push(value)
      let QCSRValuesobj = {}
      QCSRValuesobj.Lable = item
      QCSRValuesobj.Value = value
      this.QCSRValues.push(QCSRValuesobj)
    },
    AnsNumber(value, item) {
      this.QcQuestionAns[item] = value
      this.countAnswer.push(value)
      let QCSRValuesobj = {}
      QCSRValuesobj.Lable = item
      QCSRValuesobj.Value = value
      this.QCSRValues.push(QCSRValuesobj)
    },
    Savedata() {
      if (this.countAnswer.length < this.QuestionObjList.length) {
        this.$alertify.error("Please answer all questions")
      }
      else {
        this.isLoadingsave = true;
        this.input = {
          "ShippingID": this.RVPShipment,
          "HubId": this.userHubId,
          "DeliveryUserId": this.srId2,
          "TLQCParameters": this.QCSRValues,
          "LastModifiedBy":this.localusermailid
        }
        axios({
          method: 'POST',
          url: apiUrl.api_url + 'DayEndClosure/saveTLQCQuestion',
          data: this.input
        })
          .then(result => {
            if (result.data.code == 200) {
              this.isLoadingsave = false;
              this.$alertify.success("Saved successfully!!");
              this.Savebuttondisable = true
              this.Answer = []
              this.countAnswer = []
              this.QuestionObjList = []
              this.RVPQCTableData();
            }
            else if(result.data.code == 202){
              this.isLoadingsave = false;
              this.$alertify.error("TL QC already done for the shipment")
              this.countAnswer = []
            }
            else if(result.data.code == 203){
              this.isLoadingsave = false;
              this.$alertify.error("Cannot do TL QC as questions are not present")
              this.countAnswer = []
            }
            else if(result.data.code == 204){
              this.isLoadingsave = false;
              this.$alertify.error("Invalid Shipment")
              this.countAnswer = []
            }
            else{
              this.isLoadingsave = false;
              this.$alertify.error("No question answers to save")
              this.countAnswer = []
            }
            this.RVPShipment = ''
          })
      }
    },

    async uploadPODMultipleImage() {
      // this.uploadMultipleImageModal = true
      if (this.RVPShipment != "") {
        this.uploadMultipleImageModal = true
      } else {
        this.$alertify.error("Please Enter RVP Shipment for scan");
      }
    },
    openuploadMultipleImageModal() {
      this.uploadMultipleImageModal = true;
    },
    closeuploadMultipleImageModal() {
      this.uploadMultipleImageModal = false;
    },
    ClearuploadImageFile() {
      console.log("this.$refs.uploadImage1", this.$refs.uploadImage1);
      const input = this.$refs.uploadImage1;
      input.type = 'text';
      input.type = 'file';
      this.file = '';
      this.formData11 = '';
      this.validated = true
      this.uploadImage1 = {};
    },

    //Upload multiple files
    async handleFileUpload(event) {
      try {
        if (this.RVPShipment) {
          let uploadFile = event.target.files;
          this.podimagearray = []
          if(this.imageCount > 4 || uploadFile.length > 4){
            this.$alertify.error("Cannot Upload more than 4 images .");
            return false;
          }
          for (let key in uploadFile) {
            let formData = new FormData();

            if (key >= 0) {
              if (uploadFile[key].type != "image/jpeg" && uploadFile[key].type != "image/jpg" && uploadFile[key].type != "image/png") {
                this.$alertify.error("Please upload only valid file format(.jpeg, .png, .jpg)");
                this.isLoading = false;
                this.closeuploadMultipleImageModal()
                return false;
              }
            }
            if (uploadFile[key].size > (1024 * 1024 * 5)) {
              this.$alertify.error(`${uploadFile[key].name} size is greater than 5MB`, "", "error");
              this.isLoading = false;
              this.closeuploadMultipleImageModal()
              return false;
            } else {
              formData.append("ShippingID", this.RVPShipment);
              formData.append("file", uploadFile[key]);
              await axios({
                method: 'POST',
                'url': apiUrl.api_url + 'DayEndClosure/uploadS3Image',
                'data': formData
              }).then(result => {
                if (result.status == 200) {
                  this.ClearuploadImageFile();
                  this.$alertify.success(`${uploadFile[key].name} Image Uploaded Successfully`);
                  this.imageCount = this.imageCount + 1;

                } else {
                  this.$alertify.error(`${uploadFile[key].name} Image could not be uploaded.`);
                  this.isLoading = false;
                }
                this.closeuploadMultipleImageModal()
                formData = null;
              })
            }
          }
          // this.formData11 = formData;
          // this.callUploadS3Bucket(formData);
        } else {
          this.$alertify.error("Not getting Shipment id.");
          this.isLoading = true;
          this.closeuploadMultipleImageModal()
        }
      } catch (error) {
        console.log("Error", error);
        this.isLoading = false
      }
    },

    //Display NDR Reasons

    // async showNDRReason(shippingId){
    //   this.isNDRLoading = true;
    //   this.shippingId = shippingId;
    //   if (this.shippingId == '') {
    //     this.$alertify.error("Please enter ShippingId")
    //     this.isNDRLoading = false;
    //   }
    //
    //   await commonService.validateParentAwbArray(this.shippingId.split(/[\n,]+/)).then(shipmentValidation => {
    //     if (shipmentValidation) {
    //       this.EmptyResult = false;
    //       let validShipment = shipmentValidation.valid
    //       let invalidShipment = shipmentValidation.invalid
    //
    //       if (invalidShipment && invalidShipment.length > 0) {
    //         this.EmptyResult = true;
    //         this.currentInvalidShipment = invalidShipment.toString();
    //         this.isLoading = false;
    //         this.ShowTable = false;
    //       } else {
    //         this.currentValidShipment = validShipment;
    //       }
    //     }
    //   })
    //
    //   this.DeliveryUserID = parseInt(this.srItemObj.value, 10) || parseInt(this.AgentSRObj.value, 10)
    //   this.NDRReasonData = ''
    //   this.input = {
    //     "ShippingID":this.currentValidShipment[0],
    //     "HubID": this.userHubId,
    //     "DeliveryUserID": this.DeliveryUserID,
    //   }
    //   axios({
    //     method: 'POST',
    //     url: apiUrl.api_url + 'DayEndClosure/getEODShipmentNDRRReason',
    //     data: this.input
    //   })
    //   .then(result => {
    //     if (result.data.code == 200) {
    //       this.dismissCountDownSuccess = this.dismissSecs
    //       this.NDRReasonData = ''
    //       this.isLoading = false;
    //       this.isNDRLoading = false
    //       this.NDRReasonData = result.data.data.ndrreason;
    //       this.allocationSuccessMsg='NDR Reason :- '+result.data.data.ndrreason;
    //       // this.$alertify.success(result.data.message);
    //       // this.reloadP();
    //     } else {
    //       this.NDRReasonData = '',
    //       this.isLoading = false;
    //       // this.$alertify.error(result.data.message)
    //       this.isNDRLoading = false
    //     }
    //     this.dismissCountDown = this.dismissSecs
    //   })
    // },
    // updateEODBatchStatus(DeliveryUserID,HubID,LastModifiedBy){
    //   this.input = {
    //     "DeliveryUserID": DeliveryUserID,
    //     "HubID": HubID,
    //     "LastModifiedBy":LastModifiedBy
    //   }
    //   axios({
    //     method: 'POST',
    //     url: apiUrl.api_url + 'DayEndClosure/updateEODBatchStatus',
    //     data: this.input
    //   })
    //   .then(respons => {
    //     this.ShowSummaryTable(this.userHubId);

    //   })
    // }

    async getDESShipmentDetails(DECMasterID, flag, Scanned, shipmentType) {
      this.csvLoadingFlag = true;
      if(shipmentType && (Scanned == 0 || Scanned == '0')){
        this.csvLoadingFlag = false;
        this.$alertify.error("Shipments not found")
      }
      else if (Scanned == 0 || Scanned == '0') {
        this.csvLoadingFlag = false;
        this.$alertify.error("Scanned shipments not found")
      }
      else {
        let payload = {
          "DayEndClosureMasterID": parseInt(DECMasterID),
        }
        if(shipmentType){
          payload.shipmenttype = shipmentType;
        }
        if(flag == true){
          payload.scanned = flag;
        }
        axios({
          method: 'POST',
          url: apiUrl.api_url + 'get/DECShipment/Details/byUserID',
          data: payload
        })
          .then(async result => {
            if (result.data.code == 200) {
              this.shipmentDetails = [];
              this.shipmentDetails = result.data.data;
              if(payload.shipmenttype){
                let MaskedShipDetails = await this.getMaskedShipmentDetails(this.shipmentDetails);
                this.shipmentDetails = MaskedShipDetails;
              }
              this.getDownloadCsvObject(this.shipmentDetails,payload.shipmenttype);
              this.csvLoadingFlag = false;
            }
            else{
              this.$alertify.error(result.data.message)
              this.csvLoadingFlag = false;
            }
          })
      }
    },

    //Function to mask the shippingIds except last 4 digits...
    getMaskedShipmentDetails(result){
      for (let i = 0; i < result.length; i++) {
        let shippingId = result[i].shippingid;
        let maskedID = this.MaskCharacter(shippingId, 'X' , 5);
        result[i].shippingid = maskedID;
      }
      return result;
    },

    MaskCharacter(str, mask, n = 1) {
      // Slice the string and replace with mask then add remaining string
      return ('' + str).slice(0, -n).replace(/./g, mask) + ('' + str).slice(-n);
    },

    async getDownloadCsvObject(result,shipmenttype) {
      var csvData = result;
      var today = new Date();
      var dd = today.getDate();
      var mm = today.getMonth() + 1;
      var yyyy = today.getFullYear();
      var today = dd + "" + mm + "" + yyyy;
      var data, filename, link;
      if(shipmenttype && shipmenttype.includes('Delivery')){
        filename = "FW_UD_" +result[0].deliveryuserid+"_"+ today + ".csv";
      }
      else if(shipmenttype && (shipmenttype.includes('RTO') || shipmenttype.includes('DTO'))){
        filename = "RTO_DTO_UD_" +result[0].deliveryuserid+"_"+ today + ".csv";
      }
      else if(shipmenttype && shipmenttype.includes('RVP')){
        filename = "RVP_PD_" +result[0].deliveryuserid+"_"+ today + ".csv";
      }
      else{
        filename = "DEC_" +result[0].deliveryuserid+"_"+ today + ".csv";
      }
      var csv = this.convertArrayOfObjectsToCSV({
        data: csvData
      });
      if (csv == null) return;
      filename = filename || "export.csv";
      if (!csv.match(/^data:text\/csv/i)) {
        csv = "data:text/csv;charset=utf-8," + csv;
      }
      data = encodeURI(csv);
      link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.removeChild(link);
    },

    convertArrayOfObjectsToCSV: function(args) {
      var result, ctr, keys, columnDelimiter, lineDelimiter, data;
      data = args.data || null;
      if (data == null || !data.length) {
        return null;
      }
      columnDelimiter = args.columnDelimiter || ",";
      lineDelimiter = args.lineDelimiter || "\n";
      keys = Object.keys(data[0]).slice(0);
      result = "";
      result += keys.join(columnDelimiter);
      result += lineDelimiter;
      data.forEach(function(item) {
        ctr = 0;
        keys.forEach(function(key) {
          if (ctr > 0) result += columnDelimiter;
          if (item[key] != null) {
            result += '"' + item[key] + '"';
          }
          ctr++;
        });
        result += lineDelimiter;
      });
      return result;
   },
   getNDrReasonBrandedPackedId(shippingid = '', hubid = '', DeliveryUserID = '' ) {
     return new Promise((resolve, reject) => {
       try {
         //call ndr reason api.
         this.BPFlag = false;
         this.IsBrandPkgShip = false;
         this.NDRAPICalled=false;
         this.isShowDummyInput = false;
         if(shippingid != '' && hubid != '' && DeliveryUserID != '') {
           this.NDRReasonData = ''
           this.input = {
             "ShippingID": shippingid,
             "HubID": hubid,
             "DeliveryUserID": DeliveryUserID,
             "requestedBy":this.createdBy
           }
           axios({
             method: 'POST',
             url: apiUrl.api_url + 'DayEndClosure/getEODShipmentNDRRReason',
             data: this.input
           })
           .then(result => {
            this.isShowDummyInput = true;
            this.styleData = result.data.lossCategorization;

            //branded packaging id parsing from response.
            //  console.log('result--------------->',result);
             if(result.data.BPPackageID && result.data.ShipmenType != "Delivery"){
                this.shipmentsBrandPkgId = result.data.BPPackageID;
                this.IsBrandPkgShip = true;
                this.BPFlag = true;
             }

            //  console.log('this.BPFlag--------------->',this.BPFlag);

             if (result.data.code == 200) {
               this.dismissCountDownSuccess = this.dismissSecs
               this.NDRReasonData = ''
               this.isLoading = false;
               this.isNDRLoading = false
               this.NDRReasonData = result.data.data.ndrreason;
               this.allocationSuccessMsg='NDR Reason :- '+result.data.data.ndrreason;
               // this.$alertify.success(result.data.message);
               // this.reloadP();
             } else {
               this.NDRReasonData = '',
               this.isLoading = false;
               // this.$alertify.error(result.data.message)
               this.isNDRLoading = false
             }
             this.NDRAPICalled=true;
             this.dismissCountDown = this.dismissSecs
             resolve(true)
           })
         }
       }catch(e) {
         console.log('Error log', e);
       }
     })
   },
   checkBrandedPackagingIDFormatCheck(bpid) {
    if(bpid.match("[a-zA-Z0-9]")){
      return true;
   } else {
      return false;
    }
  },
  AcceptBPID(){
      this.ScanShipments(this.shippingId);
      this.$refs.shippingId.focus()
      this.closepopup();
    },

  TryAgainCountofBrandedPkgId(){
      this.brandPkgId = ''
      this.$refs.brandPkgId.focus()
      this.closepopup();
  },
  async checkBrandPkgIDIsNotAWB(){
      let input = {
        "BrandPkgId": this.brandPkgId,
        "HubID": this.userHubId,
      }
      await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'DayEndClosure/checkBrandPkgIDIsNotAWB',
        'data': input
      }).then(result => {
        if (result.data.code == 200) {
          //this.$alertify.error("You have scanned AWB, please scan BP ID..")
          this.bpidShippintMismatch = true
          this.bpidPopup = true
          this.$refs.brandPkgId.focus();
        } else {
          this.bpidShippintMismatch = false
          this.bpidPopup = true
          this.$refs.brandPkgId.focus();
        }
      })
    },
  }
}



// WEBPACK FOOTER //
// ./src/views/components/shipmentRecon/shipmentRecon.component.js